export const LANGUAGE_MOTHER = 'language-mother';